import React from "react";
import {
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import SortComponent from './SortComponent'; 
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import {useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { labelMappings } from "../../utils/utils";

// Import resetAllData function
import { reinitialiseCurrentTab, resetAllData } from '../../../../stateManagement/actions/manageCouponActions';


interface CustomToolbarProps {
  setSortParams: React.Dispatch<React.SetStateAction<string>>;
  sortParams:any,
  disabled: boolean,
}
const CustomToolbar: React.FC<CustomToolbarProps> = ({ setSortParams,sortParams, disabled }) => {
  const navigate = useNavigate();
  return (
    <GridToolbarContainer>
      {/* <GridToolbarColumnsButton/> */}
      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <FontAwesomeIcon style={{ color: "rgb(35, 198, 176)", fontSize: "1.5em", width: "1.5em", cursor: "pointer" }} icon={faArrowLeft} onClick={() => {
          window.history.back();
        }} />
        {/* <GridToolbarFilterButton />
      <SortComponent sortParams={sortParams} setSortParams={setSortParams} /> */}
      </div>
      <div style={{ marginLeft: "auto", padding: "5px", display: "flex", gap: "20px", alignItems: "center" }} className="heading-buttons">
        <SortComponent sortParams={sortParams} setSortParams={setSortParams} disabled={disabled}/>
        <div style={{ minWidth: "80px" }}>
          <GridToolbarFilterButton />
        </div>
        <button style={{ backgroundColor: "#23c6b0", display: "flex", alignItems: "center", gap: "5px", minWidth: "200px" }}
          className="default-back-button"
          onClick={() => {
            navigate("/couponDashboard/couponData")
            resetAllData();
            reinitialiseCurrentTab();
          }}
        >
          <AddIcon /> {labelMappings["createNewCoupon"]}
        </button>
      </div>
    </GridToolbarContainer>
  );
};
export default CustomToolbar;
